import React from "react";
import ti18n from "i18n!nls/GuestFeaturei18n";
import PersistentModels from "../../services/PersistentModels";
import TrebbleClientAPI from "../../models/helper/TrebbleClientAPI";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";
import PropTypes from "prop-types";
import InfiniteList, { ListItem, ListItemMeta, Skeleton } from "../common/InfiniteList";
import Button from "../common/Button";

const SharedWithMeList = (props) => {
    const {inDarkMode} = useDefaultTrebbleAntDTokenConfig();

    const fetchSharedProjects = (pageIndex, pageSize) => {
        return TrebbleClientAPI.getInstance().getProjectsSharedWithMe({
            pageOffset: pageIndex,
            numberOfResults: pageSize
        });
    };

    return (
        <InfiniteList
            containerId="sharedWithMeListContainer"
            containerHeightMargin={props.containerHeightMargin}
            containerClassname={`overflow-auto px-4 py-0 ${inDarkMode ? "" : "bg-white"} m-auto max-w-3xl`}
            locale={{ emptyText: window.getI18n(ti18n, "NO_SHARED_PROJECTS") }}
            fetchData={fetchSharedProjects}
            loader={
                <div>
                    <Skeleton className="py-5" paragraph={{ rows: 1, width: "80%" }} active />
                    <Skeleton className="py-5" paragraph={{ rows: 1, width: "80%" }} active />
                </div>
            }
            renderItem={(item, index) => {
                const projectName = item.project ? item.project.name : (item.title || item.name || window.getI18n(ti18n, "SHARED_WITH_ME_PAGE_TITLE"));
                const ownerUsername = item.owner ? item.owner.username : (item.ownerUsername || '');
                const projectId = item.projectId || item._id;
                const itemKey = item.guestRecordId || item._id || index;

                return (
                    <ListItem
                        key={itemKey}
                        actions={[
                            <Button
                                key={0}
                                type="link"
                                onClick={() => {
                                    PersistentModels.getInstance().getRouter().showCreateShortcastPageFromProject(projectId, true);
                                }}
                            >
                                <i className="pe-7s-note text-xl my-0 mx-2.5" />
                                <div className="hidden lg:inline-block">
                                    {window.getI18n(ti18n, "OPEN_PROJECT").toUpperCase()}
                                </div>
                            </Button>,
                        ]}
                    >
                        <ListItemMeta
                            title={
                                <span className="py-0 px-1">{projectName}</span>
                            }
                            description={
                                <span className="py-0 px-1">
                                    {ownerUsername
                                        ? `${window.getI18n(ti18n, "SHARED_BY")} ${ownerUsername}`
                                        : ""}
                                </span>
                            }
                        />
                    </ListItem>
                );
            }}
            pageSize={props.pageSize}
        />
    );
};

SharedWithMeList.propTypes = {
    containerHeightMargin: PropTypes.number,
    pageSize: PropTypes.number,
};

export default SharedWithMeList;
